import {useCallback, useState} from "react";
import {RESULT_EMPTY, useResultMutations, useResults} from "../../api/resultapi";
import {Section} from "../grouping/Section";
import {Button, Col, Form, FormControl, FormGroup, FormLabel} from "react-bootstrap";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {ListItemButton} from "../ListItemButton";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {useResultFileMutations} from "../../api/resultfileapi";
import {FRAGMENT_EMPTY, useFragments, useFragmentsMutations} from "../../api/htmlfragmentapi";
import {CustomEditor} from "../CustomEditor";
import {ButtonLoading} from "../ButtonLoading";

export function HtmlFragOption(props) {
    const {title} = props;
    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {fragments} = useFragments();
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {fragments ? fragments.map(a => <ListItem key={a.id} onOpenChanged={setOpen}
                                                      album={a}
                                                      onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing} setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>

    </Section>
}

function ListItem(props) {
    const {album, onOpenChanged, icon, onFileEditingChanged} = props;

    return <ListItemButton onClick={() => {
        onFileEditingChanged(album);
        onOpenChanged(true);
    }}>
        <Col className={"text-start"}>
            {album ? album.title : "Geen Titel"}
        </Col>
        <Col xs={"auto"} className={"text-end"}>
            {icon}
        </Col>
    </ListItemButton>
}

function FileOptionModalContent(props) {
    const {fileEditing, onOpenChanged, setFileEditing} = props;
    const [isLoading, setIsLoading] = useState(false);

    const {createFragment, editFragment, deleteFragment} = useFragmentsMutations();
    const initialObjectInintializer = useCallback(() => fileEditing ? {...fileEditing} : {...FRAGMENT_EMPTY}, [])


    const {tempObject, onChange, onEditorChange} = useForm(initialObjectInintializer)


    async function handleCreateSubmit(e) {
        e.preventDefault();
        const result = await createFragment(tempObject);
        onOpenChanged(false);

    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const result = await editFragment(tempObject);
        if (result) {

        }
        setIsLoading(false);


    }


    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Form>
            <Section title={fileEditing ? "Wijzig fragment" : "Nieuw fragment"}>
                <FormGroup>
                    <FormLabel>Titel</FormLabel>
                    <FormControl value={tempObject ? tempObject.title : ""}
                                 onChange={event => onChange(event, "title")}/>
                </FormGroup>
                <FormGroup>
                    <Form.Label>{"Inhoud"}</Form.Label>
                    <CustomEditor initText={fileEditing ? fileEditing.html : ""} fieldName={"html"}
                                  onEditorChange={onEditorChange}/>
                </FormGroup>


                {fileEditing ?

                    <Col xs={6}>

                        <Button onClick={async () => {
                            const message = await deleteFragment(fileEditing);
                            if (message) onOpenChanged(false);
                            setFileEditing(undefined);
                        }} className={"btn-danger mt-3"}>Delete</Button>
                    </Col> : ""}
                <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading isLoading={isLoading} title={"Opslaan"} onClick={event => {
                        setIsLoading(true);
                        fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
                    }}/>
                </Col>

            </Section>
        </Form>
    </ModalContentContainer>
}

